import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/image': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h416zM458 400c3.3 0 6-2.7 6-6v-276c0-3.3-2.7-6-6-6h-404c-3.3 0-6 2.7-6 6v276c0 3.3 2.7 6 6 6h404zM128 152c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM96 352v-48l39.5-39.5c4.7-4.7 12.3-4.7 17 0l39.5 39.5 119.5-119.5c4.7-4.7 12.3-4.7 17 0l87.5 87.5v80h-320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/image.js
// module id = 1779
// module chunks = 0